<script setup lang="ts">
// Small avatar cluster: a row of 5 overlapping discs of coloured card stock (the
// spreads' stocks), each a sticker with a cream die-cut ring and a small ink glyph
// (paw / spark — no photos). Hand-cut, a little askew. Decorative.
import { PawPrint, Sparkle } from '@lucide/vue';

const props = withDefaults(
  defineProps<{
    /** The die-cut ring between the overlapping discs. */
    borderColor?: string
    size?: number
  }>(),
  {
    borderColor: 'var(--paper-stock)',
    size: 38,
  },
)

const stocks = ['bg-stock-plum', 'bg-stock-rust', 'bg-stock-wine', 'bg-stock-tide', 'bg-stock-bronze']
const TILTS = [-6, 4, -3, 7, -5]
</script>

<template>
  <div
    class="flex"
    aria-hidden="true"
  >
    <span
      v-for="(s, i) in stocks"
      :key="i"
      class="trust-disc flex items-center justify-center text-foreground"
      :class="s"
      :style="{
        width: props.size + 'px',
        height: props.size + 'px',
        marginLeft: i ? '-10px' : '0',
        '--ring': props.borderColor,
        transform: `rotate(${TILTS[i]}deg)`,
      }"
    >
      <PawPrint
        v-if="i % 2 === 0"
        :size="props.size * 0.42"
        :stroke-width="2"
      />
      <Sparkle
        v-else
        :size="props.size * 0.4"
        :stroke-width="2"
      />
    </span>
  </div>
</template>

<style scoped>
/* A hand-cut disc of stock, stuck on like a sticker: a cream die-cut ring + a soft lift. */
.trust-disc {
  border-radius: 52% 48% 50% 46% / 48% 52% 46% 50%;
  box-shadow:
    inset 0 1px 0 var(--paper-edge),
    0 0 0 2px var(--ring),
    0 4px 6px -2px var(--paper-shade);
}
</style>
